const {
  i18n: { __ },
  components: { TextControl, ToggleControl },
} = wp;

const HubspotSettings = (props) => {
  const { attributes, setAttributes } = props;
  const { hubspotForm } = attributes;

  return (
    <>
      <TextControl
        label={__('Region', 'b3rg')}
        value={hubspotForm.regionId}
        onChange={(newValue) => {
          setAttributes({
            hubspotForm: {
              ...hubspotForm,
              regionId: newValue,
            },
          });
        }}
      />

      <TextControl
        label={__('Portal ID', 'b3rg')}
        value={hubspotForm.portalId}
        onChange={(newValue) => {
          setAttributes({
            hubspotForm: {
              ...hubspotForm,
              portalId: newValue,
            },
          });
        }}
      />

      <TextControl
        label={__('Form ID', 'b3rg')}
        value={hubspotForm.hubspotFormId}
        onChange={(newValue) => {
          setAttributes({
            hubspotForm: {
              ...hubspotForm,
              hubspotFormId: newValue,
            },
          });
        }}
      />

      <TextControl
        label={__('Campaign ID', 'b3rg')}
        value={hubspotForm.sfdcCampaignId}
        onChange={(newValue) => {
          setAttributes({
            hubspotForm: {
              ...hubspotForm,
              sfdcCampaignId: newValue,
            },
          });
        }}
      />

      <ToggleControl
        label={__('Enable CSS', 'b3rg')}
        help={__(
          'This option will remove the iframe and allow you to do custom styling',
          'b3rg',
        )}
        checked={hubspotForm.enableCss}
        onChange={(newValue) => {
          setAttributes({
            hubspotForm: {
              ...hubspotForm,
              enableCss: newValue,
            },
          });
        }}
      />
    </>
  );
};

export default HubspotSettings;
